import React from 'react'
import AboutUs from '../about-us'

const AboutUsPl = () => {
    return <AboutUs languageCode="pl" />
}

export default AboutUsPl
